import React from 'react';

import { DEFAULT_STROKE_PATTERN } from './default-stroke-pattern';

type StrokePatternsPaletteContext = {
  getStrokePattern: <T>(
    key?: T,
    scope?: string,
  ) => T extends string ? number[] | undefined : number[];
};

export const StrokePatternsPaletteContext = React.createContext<StrokePatternsPaletteContext>({
  getStrokePattern: ((key?: any) => {
    if (typeof key === 'string' || typeof key === 'undefined') {
      return undefined;
    }

    return DEFAULT_STROKE_PATTERN;
  }) as StrokePatternsPaletteContext['getStrokePattern'],
});
